'use client';

import { useCallback } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';

import RenderMaps from 'src/components/shared/map/map';

import { useAppDispatch, useAppSelector } from 'src/hooks/redux-hooks';
import { updateVisibility } from 'src/redux/modals/slice';

const LocationMapModal = () => {
  const dispatch = useAppDispatch();

  const handleCloseModal = useCallback(
    () => {
      dispatch(updateVisibility({ modalType: 'mapModal', isVisible: false }));
    },
    [dispatch],
  );

  const { extraProps } = useAppSelector((state: Record<string, unknown>) => {
    const modals = state?.modals as Record<string, unknown>;
    return modals?.mapModal as Record<string, unknown>;
  });

  const modalData = (
    extraProps as Record<string, unknown>
  )?.modalData as
    Record<string, unknown> | undefined;

  return (
    <Modal
      isOpen
      toggle={handleCloseModal}
      centered
      className="location-map-modal"
    >
      <ModalHeader toggle={handleCloseModal}>
        {modalData?.address as string}
        <div className="job-count-btn">
          {modalData?.job_count as string | number}
          {' '}
          Jobs
        </div>
      </ModalHeader>
      <ModalBody>
        <div className="maps">
          <RenderMaps
            center={{
              lat: modalData?.latitude as number,
              lng: modalData?.longitude as number,
            }}
            containerStyle={{
              width: '400px',
              height: '400px',
            }}
          />
        </div>
      </ModalBody>
    </Modal>
  );
};

export default LocationMapModal;
